import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/07d9b5d2c33605ab9823e3f3ab6bc29d.jpg" 
          alt="Cosmic Background" 
          className="w-full h-full object-cover object-center opacity-60"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-purple-900/60 via-purple-800/40 to-purple-900/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-6"
        >
          <span className="inline-block px-6 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full text-white text-sm font-medium tracking-wider">
            OhMyGAWD • GUIDANCE • AWARENESS • WISDOM • DIRECTION
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight bg-gradient-to-r from-white via-teal-300 to-white bg-clip-text text-transparent"
          style={{ 
            fontFamily: "'Cinzel', serif",
            fontVariant: 'small-caps',
            letterSpacing: '0.05em'
          }}
        >
          Seeking your digital Oracle?
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="my-16 flex justify-center"
        >
          <div className="relative w-full max-w-2xl h-96">
            <img 
              src="https://readdy.ai/api/search-image?query=ornate%20mystical%20fortune%20teller%20arcade%20machine%20with%20glowing%20crystal%20ball%20centerpiece%2C%20art%20deco%20golden%20frame%20with%20intricate%20circuit%20board%20patterns%2C%20neon%20purple%20and%20cyan%20accent%20lights%2C%20vintage%20carnival%20aesthetic%20merged%20with%20futuristic%20AI%20technology%2C%20magical%20aura%20and%20energy%20particles%20surrounding%20the%20machine%2C%20dark%20background%20with%20dramatic%20lighting%20highlighting%20the%20oracle%20device&width=800&height=600&seq=oracle-machine-001&orientation=landscape" 
              alt="OhMyGAWD Oracle Machine" 
              className="w-full h-full object-contain drop-shadow-2xl"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-purple-900/50 via-transparent to-transparent pointer-events-none"></div>
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-white text-xl md:text-2xl font-light max-w-3xl mx-auto mb-12 leading-relaxed"
        >
          Experience AI-powered guidance for the modern seeker. Ask your questions and receive cosmic wisdom, mystical insights, and meaningful direction.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
        >
          <a href="/oracle" className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-500 text-white text-lg font-semibold rounded-full hover:shadow-2xl hover:shadow-purple-500/50 transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer">
            Ask OhMyGAWD Now
            <i className="ri-arrow-right-line"></i>
          </a>
          <a href="/auth" className="px-8 py-4 bg-transparent border-2 border-white text-white text-lg font-semibold rounded-full hover:bg-white hover:text-purple-900 transition-all whitespace-nowrap cursor-pointer">
            Subscribe for $9.95/mo
          </a>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="mt-6 text-white/80 text-sm"
        >
          <a href="/auth" className="hover:text-cyan-400 transition-colors cursor-pointer">
            Try one free question →
          </a>
        </motion.p>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#FFF8F0] to-transparent pointer-events-none"></div>
    </section>
  );
};

export default HeroSection;
